/**
 * Agency read view of TikTok, Snap and LinkedIn Ads (ads module, /v1/ads-{tiktok,snap,linkedin}/agency/...).
 * Grant-gated (active partner_client_grants with read:reports) and behind the connectors.agency_networks flag:
 * every call answers 404 feature_disabled while it is off. Read-only; there is no write here.
 */
import type { AgencyNetworkClients, AgencyNetworkProvider, AgencyNetworkReport } from '@qm/contracts/connectors';
import { seg, type Http } from '../kit/http';

export type { AgencyNetworkClients, AgencyNetworkProvider, AgencyNetworkReport };
export const NETWORKS: readonly AgencyNetworkProvider[] = ['tiktok', 'snap', 'linkedin'];
const base = (p: AgencyNetworkProvider) => `/v1/ads-${p}/agency` as const;

export function adsNetworksApi(http: Http) {
  return {
    clients: (p: AgencyNetworkProvider) => http.get<AgencyNetworkClients>(`${base(p)}/clients`),
    report: (p: AgencyNetworkProvider, clientTenantId: string, q: { from: string; to: string }) =>
      http.get<AgencyNetworkReport>(`${base(p)}/clients/${seg(clientTenantId)}/performance`, q),
  };
}
